// extracted by mini-css-extract-plugin
export default {"main":"Categories_main__UPHK3","active":"Categories_active__p7L8S","dropdwn":"Categories_dropdwn__b9cTv"};